export function invalidateInputs(holder, name) {
    holder.querySelector(`[name="${name}"]`).setAttribute('aria-invalid', 'true');
}

export function showNotice(noticeElement, json) {
    const newNoticeElement = noticeElement;

    newNoticeElement.setAttribute('aria-hidden', 'false');
    if (json.length > 0) {
        newNoticeElement.innerHTML += `<div class="p-3">${json}</div>`;
    } else {
        newNoticeElement.innerHTML += '<div class="p-3">Er ging helaas iets mis bij het verzenden van het formulier.</div>';
    }
}

export function hideNotice(formElement, noticeElement) {
    const newNoticeElement = noticeElement;

    newNoticeElement.setAttribute('aria-hidden', 'true');
    newNoticeElement.innerHTML = '';

    formElement.querySelectorAll('[aria-invalid="true"]').forEach((elem) => {
        elem.removeAttribute('aria-invalid');
    });
}
